import { Rule } from "./rule";

export class QueryBuilder {
  brandId: number;
  condition: string;
  rules: Array<Rule> = [];
}
